import React from 'react';
import Modal from "../Modal";
import TabBar from "../TabBar";
import { inject, observer } from "mobx-react/index";

@inject('userStore')
@observer
class UserPermission extends React.Component {

  slug = 'user';
  componentWillMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  render() {
    const { userStore, children, params: { id } } = this.props;
    let user = userStore.findById(id);
    return (
      <Modal title={user ? user.name + ' - User Permission' : 'User Permission'} slug={this.slug}>
        <div><br/>
          <TabBar items={[
            { to: `/user/${id}/permission/station`, label: 'Station' },
            { to: `/user/${id}/permission/parameter`, label: 'Parameter' },
          ]} rounded />
          {children}
        </div>
      </Modal>
    );
  }
}

export default UserPermission;


// WEBPACK FOOTER //
// ./src/components/User/UserPermission.js